import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React__default from 'react';

const tableTitleCellStyles = (theme) => createStyles({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: "nowrap",
    paddingRight: theme.spacing(4),
    border: "0",
    verticalAlign: "top"
  }
});
const tableContentCellStyles = {
  root: {
    border: "0",
    verticalAlign: "top"
  }
};
const listStyles = (theme) => createStyles({
  root: {
    margin: theme.spacing(0, 0, -1, 0)
  }
});
const listItemStyles = (theme) => createStyles({
  root: {
    padding: theme.spacing(0, 0, 1, 0)
  },
  random: {}
});
const TitleCell = withStyles(tableTitleCellStyles, {
  name: "BackstageMetadataTableTitleCell"
})(TableCell);
const ContentCell = withStyles(tableContentCellStyles, {
  name: "BackstageMetadataTableCell"
})(TableCell);
const MetadataTable = ({
  dense,
  children
}) => /* @__PURE__ */ React__default.createElement(Table, { size: dense ? "small" : "medium" }, /* @__PURE__ */ React__default.createElement(TableBody, null, children));
const MetadataTableItem = ({
  title,
  children,
  ...rest
}) => /* @__PURE__ */ React__default.createElement(TableRow, null, title && /* @__PURE__ */ React__default.createElement(TitleCell, null, title), /* @__PURE__ */ React__default.createElement(ContentCell, { colSpan: title ? 1 : 2, ...rest }, children));
const MetadataList = withStyles(listStyles, {
  name: "BackstageMetadataTableList"
})(({ classes, children }) => /* @__PURE__ */ React__default.createElement(List, { disablePadding: true, className: classes.root }, children));
const MetadataListItem = withStyles(listItemStyles, {
  name: "BackstageMetadataTableListItem"
})(({ classes, children }) => /* @__PURE__ */ React__default.createElement(ListItem, { className: classes.root }, children));

export { MetadataList, MetadataListItem, MetadataTable, MetadataTableItem };
//# sourceMappingURL=MetadataTable.esm.js.map
